import { render, staticRenderFns } from "./Types.vue?vue&type=template&id=045b222a&scoped=true"
import script from "./Types.vue?vue&type=script&lang=js"
export * from "./Types.vue?vue&type=script&lang=js"
import style0 from "./Types.vue?vue&type=style&index=0&id=045b222a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045b222a",
  null
  
)

export default component.exports